import type { ReactNode } from 'react';

export const symbol_link_2: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M313-120q-81 0-137-56t-56-137q0-38 14.48-73.28Q148.97-421.56 176-449l124-125q9-9 21.5-8.5T343-573q9 9 9 21t-9 21L218-407q-19 19-29 43.49-10 24.49-10 50.69 0 55.82 39.15 94.32Q257.3-180 312.9-180q26.1 0 50.6-10t43.5-29l125-124q9-8 21-8.5t21 8.5q9 9 9 21t-9 21L449-176q-27.44 27.03-62.72 41.52Q351-120 313-120Zm59-252.05q-9-9.06-9-21.5 0-12.45 9-21.45l173-172q8.8-9 20.9-9 12.1 0 21.1 8.84 9 8.84 9 21T587-545L415-372q-9.07 9-21.53 9-12.47 0-21.47-9.05ZM617-386q-9-9-9.5-21t8.5-21l125-125q18-18 28-41.56 10-23.55 10-49.35 0-56.09-38.34-95.59T645.94-779q-25.94 0-49.95 9.5T553-741L428-616q-9 9-21 9t-21-8.84q-9-8.84-9-21t9-21.16l125-125q27-27 62.5-42t73.5-15q81 0 137 56.54t56 137.44q0 38.02-14.5 73.52Q811-537 784-510L659-386q-8.8 9-20.9 9-12.1 0-21.1-9Z"
		/>
	</svg>
);
